import { toast } from "sonner";

import { useSimulator } from "@/v2/features/simulator/context/SimulatorWrapper";

import { OptionalTextarea } from "./OptionalTextarea";
import { FieldGroup } from "./FieldGroup";

export function UpdateCustomTonePrompt() {
  const { currentRelease, updateRelease } = useSimulator();

  return (
    <FieldGroup
      label={
        currentRelease?.customToneOfVoice
          ? "Edit Custom Tone Prompt"
          : "Add Custom Tone Prompt"
      }
      description={
        "Add here system prompt to customize the tone of the agent's responses. Changes will be relevant from the next published release."
      }
    >
      <OptionalTextarea
        value={currentRelease?.customToneOfVoice}
        onChange={(newValue) => {
          if (currentRelease?.id) {
            updateRelease(currentRelease?.id.toString(), {
              simulatorId: currentRelease?.simulatorId,
              customToneOfVoice: newValue,
            });
          } else {
            toast.error("Something went wrong, please try again");
          }
        }}
        buttonText={"Add custom tone prompt"}
        label={"Custom Tone Prompt"}
      />
    </FieldGroup>
  );
}
